<template>
  <div>
    <span class="text-sm" v-if="sku == 'PICK'">Surprise me</span>
    <span class="text-sm" v-else>{{flavour.name}}</span>
  </div>
</template>

<script>
import { find } from 'lodash';

export default {
  props: ['sku'],
  computed: {
    flavour() {
      return find(this.$root.$data.flavours, {id: this.sku})
    }
  }

}
</script>

<style>

</style>